import script from "./legoTooltipExtend.vue?vue&type=script&lang=js"
export * from "./legoTooltipExtend.vue?vue&type=script&lang=js"

import "./legoTooltipExtend.vue?vue&type=style&index=0&id=579da675&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-579da675"],['__file',"src/components/lego/extend/legoTooltipExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "579da675"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('579da675', __exports__)) {
    api.reload('579da675', __exports__)
  }
  
}


export default __exports__